import { createBrowserRouter } from "react-router-dom";
import React from "react";
import { RootLayout } from "../Layout/RootLayout";
import Loader from "../../common/Loader/Loader";
import HousePage from "../../pages/House";
import HouseSummary from "../../pages/HouseSummary";

const Home = React.lazy(() => import("./../../pages/Home"));
const About = React.lazy(() => import("./../../pages/About"));
const Services = React.lazy(() => import("./../../pages/Services"));
const Service = React.lazy(() => import("./../../pages/Service"));
const Contact = React.lazy(() => import("./../../pages/Contact"));
const Disputes = React.lazy(() => import("./../../pages/Disputes"));
const Privacy = React.lazy(() => import("./../../pages/Privacy"));
const Registries = React.lazy(() => import("./../../pages/Registries"));
const RCA = React.lazy(() => import("./../../pages/RCA"));
const RCASummary = React.lazy(() => import("./../../pages/RCASummary"));
const PAD = React.lazy(() => import("./../../pages/PAD"));
const PADSummary = React.lazy(() => import("./../../pages/PADSummary"));
const NotFound = React.lazy(() => import("./../../pages/NotFound"));
const RouteError = React.lazy(() => import("./../../pages/RouteError"));
const TermsAndConditions = React.lazy(
  () => import("./../../pages/TermsAndConditions")
);
const Pid = React.lazy(() => import("./../../pages/Pid"));
const Travel = React.lazy(() => import("./../../pages/Travel"));
const TravelSummary = React.lazy(() => import("./../../pages/TravelSummary"));

export const Router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <RouteError />,
    children: [
      {
        index: true,
        element: (
          <React.Suspense fallback={<Loader />}>
            <Home />
          </React.Suspense>
        ),
      },
      {
        path: "despre",
        element: (
          <React.Suspense fallback={<Loader />}>
            <About />
          </React.Suspense>
        ),
      },
      {
        path: "servicii",
        element: (
          <React.Suspense fallback={<Loader />}>
            <Services />
          </React.Suspense>
        ),
      },
      {
        path: "servicii/*",
        element: (
          <React.Suspense fallback={<Loader />}>
            <Service />
          </React.Suspense>
        ),
      },
      {
        path: "contact",
        element: (
          <React.Suspense fallback={<Loader />}>
            <Contact />
          </React.Suspense>
        ),
      },
      {
        path: "litigii",
        element: (
          <React.Suspense fallback={<Loader />}>
            <Disputes />
          </React.Suspense>
        ),
      },
      {
        path: "politica-de-confidentialitate",
        element: (
          <React.Suspense fallback={<Loader />}>
            <Privacy />
          </React.Suspense>
        ),
      },
      {
        path: "termeni-si-conditii",
        element: (
          <React.Suspense fallback={<Loader />}>
            <TermsAndConditions />
          </React.Suspense>
        ),
      },
      {
        path: "registre",
        element: (
          <React.Suspense fallback={<Loader />}>
            <Registries />
          </React.Suspense>
        ),
      },
      {
        path: "rca",
        element: (
          <React.Suspense fallback={<Loader />}>
            <RCA />
          </React.Suspense>
        ),
      },
      {
        path: "rca/:offerId",
        element: (
          <React.Suspense fallback={<Loader />}>
            <RCASummary />
          </React.Suspense>
        ),
      },
      {
        path: "pad",
        element: (
          <React.Suspense fallback={<Loader />}>
            <PAD />
          </React.Suspense>
        ),
      },
      {
        path: "pad/:offerId",
        element: (
          <React.Suspense fallback={<Loader />}>
            <PADSummary />
          </React.Suspense>
        ),
      },
      {
        path: "pid",
        element: (
          <React.Suspense fallback={<Loader />}>
            <Pid />
          </React.Suspense>
        ),
      },
      {
        path: "travel",
        element: (
          <React.Suspense fallback={<Loader />}>
            <Travel />
          </React.Suspense>
        ),
      },
      {
        path: "travel/:offerId",
        element: (
          <React.Suspense fallback={<Loader />}>
            <TravelSummary />
          </React.Suspense>
        ),
      },
      {
        path: "house",
        element: (
          <React.Suspense fallback={<Loader />}>
            <HousePage />
          </React.Suspense>
        ),
      },
      {
        path: "house/:offerId",
        element: (
          <React.Suspense fallback={<Loader />}>
            <HouseSummary />
          </React.Suspense>
        ),
      },
      // 404 route
      {
        path: "*",

        element: (
          <React.Suspense fallback={<Loader />}>
            <NotFound />
          </React.Suspense>
        ),
      },
    ],
  },
]);
